import React from 'react';
import { Checkbox, ICheckboxProps } from '@blueprintjs/core';
import { TranslatedMessage } from '../../translation';
import { Overwrite } from '../../../../typings/typings';
import { TLCode } from '../../../../common/enums';
import styled from '@emotion/styled';

const ContainerCheckbox = styled.div`
  display: flex;
  flex-direction: row;
  `;

// tslint:disable-next-line:no-empty-interface
interface CommonCheckboxInputProps extends ICheckboxProps {
}

export type CheckboxInputProps = Overwrite<CommonCheckboxInputProps, { label?: TLCode }>;

const renderCheckbox = (props: ICheckboxProps) => <Checkbox {...props} />;

const CheckboxInput = ({ label, ...otherProps }: CheckboxInputProps) => {
  if (label !== undefined) {
    const checkbox = renderCheckbox({ ...otherProps });
    return (
      <ContainerCheckbox>
        {checkbox}
        <TranslatedMessage id={label}/>
      </ContainerCheckbox>
    );
  } else {
    return renderCheckbox({ ...otherProps });
  }
};

export default CheckboxInput;
